export default __webpack_public_path__ + "static/media/stop.71aedef5.svg";